<template>
  <v-container fluid class="country-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Country Information</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Country</p>
                        <v-text-field
                          class="mb-4"
                          v-model="country.countrycode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Country Code"
                          persistent-hint
                          single-line hint="Enter the country Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="country.countryname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Country Name"
                          persistent-hint
                          single-line hint="Enter the country name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="country.countryinfo"
                          outlined
                          dense
                          placeholder="Country Info"
                          persistent-hint
                          single-line hint="Enter the country info">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=countrytype
                          v-model="country.countrytype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the country type">
                        </v-select>
                          <v-switch
                            v-model="country.countrystatus"
                            color="primary"
                            v-bind:label="country.countrystatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/country/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertCountry()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      country: {
        countrystatus: 'Active'
      },
      countrytype: ['Country', 'Other Country'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Country', ['insertCountryRequest','getCountriesRequest']),
    checkError(){
      if(!this.country.countrycode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.country.countryname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.country.countrytype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertCountry() {
      if(!this.checkError()) return;
      this.insertCountryRequest(this.country)
      await this.getCountriesRequest()
      router.push('/country/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.country.countryimage = file;
      this.country.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Country', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
